import React from 'react';

const Encyklopedia = () => {
  return <h1>Encyklopedia Page</h1>;
};

export default Encyklopedia;
